import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppService, GRSSUserRoles, ValueIdPair } from 'src/app/_services/app.service';
import * as shape from 'd3-shape';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.css'],
    standalone: false
})
export class SummaryComponent implements OnInit, OnDestroy {

  // displayColumns: string[] = ['markets', 'window', 'timeToOpen', 'timeToClose'];
  displayColumns: string[] = ['graph', 'summary'];
  dataSource;
  marketsLength = 0;
  intervals: any[] = [];
  summaryNote: string = '';

  linearCurve = shape.curveBasis;

  multi: any[] = [];
  view: any[] = [700, 250];

  // options
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Year';
  yAxisLabel: string = 'Population';
  timeline: boolean = true;

  isLoading: boolean = false;

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private service: AppService, private router: Router) {
    this.service.SetTranslation('tools/summary');
   }

  ngOnInit() {
    this.GetMarkets();
  }

  ngOnDestroy() {
    if (this.intervals.length > 0) {
      this.intervals.forEach(interval => {
        clearInterval(interval);
      });
    }
  }

  /** List all the markets and sets the intervals to get updated data  */
  GetMarkets() {
    this.isLoading = true;
    this.http.get<SummaryPage>(this.baseUrl + 'api/common/summaryMarkets').subscribe(result => {
      this.marketsLength = result.marketlist.length;
      this.summaryNote = result.summaryNote;
      this.dataSource = new MatTableDataSource(result.marketlist);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      if (this.marketsLength > 0) {
        result.marketlist.forEach(o => {
            const interval = setInterval(() => {
            this.service.GetRemainingTime(o.marketId, 'Contribution Start').then(res => {
              o.timeToOpen = res.time;
            });
            this.service.GetRemainingTime(o.marketId, 'Contribution Finish').then(res => {
              o.timeToClose = res.time;
            });
          }, 1000);
          this.intervals.push(interval);

          o.historyDataClient = [];

          o.historyData.forEach(historyData => {
            const record: any = {};
            const recordRates: any[] = [];

            historyData.rates.forEach(rate => {
              const recordRate: any = {};
              recordRate['name'] = rate.id;
              recordRate['value'] = rate.value;
              recordRates.push(recordRate);
            });

            record['name'] = historyData.instrumentName;
            record['series'] = recordRates;

            o.historyDataClient.push(record);
          });
        });
      }
    }, error => {
      console.error(error);
    }, () => {
      this.isLoading = false;
    });
  }

  OnMarketClick(marketId: string) {
    if (this.service.currentUser.userRole === GRSSUserRoles.Assessor) {
      const assessMarket = this.service.currentUser.userAssessMarkets.find(ele => ele.marketId === marketId);
      if (assessMarket) {
        this.router.navigate(['contribute/assess'], { queryParams: {ID: marketId} });
      }
    } else {
      const contributeMarket = this.service.currentUser.userContributeMarkets.find(ele => ele.marketId === marketId);
      if (contributeMarket) {
        this.router.navigate(['contribute/contribute'], { queryParams: {ID: marketId} });
      }
    }
  }
}

/** An interface to access summary market details */
interface SummaryMarket {
  marketId: string;
  marketDescription: string;
  conStartTime: string;
  conFinishTime: string;
  timeToOpen: string;
  timeToClose: string;
  historyData: HistoryData[];
  historyDataClient: any[];
}

interface HistoryData {
  instrumentName: string;
  rates: ValueIdPair[];
}

interface SummaryPage {
  summaryNote: string;
  marketlist: SummaryMarket[];
}
